import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import AccountMessageBox from './AccountMessageBox';
import {
  selectAllUserMessages,
  dismissUserMessage,
} from '../../../redux/slices/sessionSlice';

const LatestAccountMessageBox = () => {
  const dispatch = useDispatch();
  const userMessages = useSelector(selectAllUserMessages);

  // Get the first message if available
  const latestMessage = userMessages.length > 0 ? userMessages[0] : null;

  const handleDismiss = (messageId) => {
    dispatch(dismissUserMessage(messageId));
  };

  // Render nothing if no messages
  if (!latestMessage) {
    return null;
  }

  return (
    <AccountMessageBox
      message={latestMessage}
      showDate={false}
      id={latestMessage.id}
      onDismiss={handleDismiss}
    />
  );
};

export default LatestAccountMessageBox;
